var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8.75V17H3L3 8.75L10 3.5L17 8.75ZM1 8.75C1 8.12049 1.29639 7.52771 1.8 7.15L8.8 1.9C9.51111 1.36667 10.4889 1.36667 11.2 1.9L18.2 7.15C18.7036 7.52771 19 8.12049 19 8.75V17C19 18.1046 18.1046 19 17 19H3C1.89543 19 1 18.1046 1 17V8.75ZM13.9201 13.1183C14.2345 12.3754 13.5766 11.5558 12.7233 11.7015V11.7027C12.3716 11.7628 12.0735 11.9851 11.9272 12.2952C11.6659 12.8471 11.1398 13.2681 10.4789 13.3807C9.41452 13.5623 8.3775 12.8583 8.19786 11.8153C8.1757 11.6879 8.16753 11.5617 8.17161 11.4373C8.20078 10.5505 8.86685 9.7793 9.79713 9.62069C9.93244 9.5977 10.0666 9.58826 10.1984 9.59239C10.5933 9.60359 10.9665 9.73037 11.2768 9.9444C11.3684 10.0081 11.4547 10.0788 11.5346 10.1567C11.786 10.4019 12.1459 10.5146 12.4987 10.4544C12.8983 10.3866 13.1829 10.1313 13.3141 9.8194C13.4669 9.4556 13.4127 9.01456 13.0832 8.69204C12.1686 7.7964 10.8324 7.33178 9.45301 7.55583C8.29935 7.74333 7.34107 8.37069 6.72924 9.22919C6.30347 9.82529 6.04567 10.5334 6.00543 11.284C5.99026 11.5706 6.00659 11.8642 6.05792 12.1602C6.21131 13.0435 6.65167 13.8094 7.27224 14.3849C8.19203 15.2369 9.50551 15.6691 10.8569 15.4385C12.2503 15.2003 13.3549 14.3147 13.9015 13.1602C13.903 13.1568 13.9045 13.1534 13.9061 13.1501C13.9109 13.1395 13.9157 13.1291 13.9201 13.1183Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.390877401df9fe8d7eafe62876cdbeee.svg";
export { ForwardRef as ReactComponent };